import { atom } from "recoil";

export const LoggedUser = atom ({
    key: "userLogged",
    default: {
        email:'',
        id: 0,
        idEmpresa: 0,
        idLoginTipo: 0,
        nome: '',
    },
    effects_UNSTABLE: [
        ({ setSelf }) => {
          const todos = localStorage.getItem("user");
    
          if (todos === null || todos === undefined) {
            setSelf({
                email:'',
                id: 0,
                idEmpresa: 0,
                idLoginTipo: 0,
                nome: '',
            });
          } else {
            setSelf(JSON.parse(todos));
          }
        },
      ],
    

});